import React from "react";

const LinkedinIcon: React.FC = () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75001 30H0.374994V9.9375H6.75001V30ZM3.5625 7.125C1.5 7.125 0 5.625 0 3.5625C0 1.5 1.6875 0 3.5625 0C5.625 0 7.12501 1.5 7.12501 3.5625C7.12501 5.625 5.625 7.125 3.5625 7.125ZM30 30H23.625V19.125C23.625 15.9375 22.3125 15 20.4375 15C18.5625 15 16.6875 16.5 16.6875 19.3125V30H10.3125V9.9375H16.3125V12.75C16.875 11.4375 19.125 9.375 22.3125 9.375C25.875 9.375 29.625 11.4375 29.625 17.625V30H30Z"
        fill="white"
      />
    </svg>
  );

export default LinkedinIcon;
